/**
 * share.js — nút chia sẻ ở chân bài viết (.post-share).
 *
 * Markup cần:
 *   <a class="post-share__btn" href="https://www.facebook.com/sharer/…" data-share-popup>…</a>
 *   <button class="post-share__btn" type="button" data-share-copy [data-share-url="…"]>…</button>
 *
 * Link Facebook / Messenger dựng sẵn ở server (rawurlencode( get_permalink() )) nên không
 * cần SDK; JS chỉ mở chúng trong cửa sổ nhỏ thay vì tab mới — không JS thì vẫn là link
 * target="_blank" bình thường. Nút chép link lấy data-share-url, không có thì lấy URL
 * trang hiện tại (bỏ #anchor của mục lục).
 *
 * Chép: navigator.clipboard khi có (https, localhost), không thì rơi về textarea +
 * execCommand('copy') — file:// và trình duyệt cũ vẫn chép được. Báo kết quả bằng
 * WBToast (toast.js) và đổi aria-label của nút trong 2 giây.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var COPIED_LABEL = 'Đã chép link';

    function notify(message, icon) {
        // toast.js đứng sau share.js theo thứ tự gộp file — gọi lúc bấm thì nó đã có
        if (window.WBToast) window.WBToast.show(message, { icon: icon });
    }

    function legacyCopy(text) {
        var area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        var ok = false;
        try {
            ok = document.execCommand('copy');
        } catch (e) {
            ok = false;
        }
        document.body.removeChild(area);
        return ok;
    }

    function copy(text, done) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(
                function () {
                    done(true);
                },
                function () {
                    done(legacyCopy(text));
                }
            );
            return;
        }
        done(legacyCopy(text));
    }

    document.addEventListener('click', function (event) {
        var target = event.target.closest ? event.target.closest('[data-share-copy], [data-share-popup]') : null;
        if (!target) return;

        if (target.hasAttribute('data-share-popup')) {
            // Không truyền "noopener" vào features: khi đó window.open luôn trả null và link
            // sẽ mở thêm một tab nữa. Cắt opener bằng tay ngay sau khi mở.
            var popup = window.open(target.href, 'wb-share', 'width=620,height=560');
            // Popup bị chặn thì để link tự mở tab mới như không có JS
            if (popup) {
                popup.opener = null;
                event.preventDefault();
            }
            return;
        }

        event.preventDefault();
        var url = target.getAttribute('data-share-url') || window.location.href.split('#')[0];
        var original = target.getAttribute('aria-label') || '';

        copy(url, function (ok) {
            if (!ok) {
                notify('Không chép được — hãy sao chép link trên thanh địa chỉ.', 'ph-bold ph-warning-circle');
                return;
            }
            target.classList.add('is-copied');
            target.setAttribute('aria-label', COPIED_LABEL);
            notify('Đã chép link bài viết', 'ph-fill ph-check-circle');
            window.clearTimeout(target._shareTimer);
            target._shareTimer = window.setTimeout(function () {
                target.classList.remove('is-copied');
                target.setAttribute('aria-label', original);
            }, 2000);
        });
    });
})();
